import { HorizontalDivider, VerticalDivider } from "@@/shared/dividers";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { Icon } from "@@/shared/icons/icon";
import { TextBox } from "@@/shared/text";
import { useTheme } from "@emotion/react";
import {
    faClipboardCheck,
    faHeart,
    faUsers,
} from "@fortawesome/pro-solid-svg-icons";
import { translation } from "@towni/common";

const AccommodationUspInfoBlock = () => {
    const theme = useTheme();
    return (
        <FlexColumn>
            <FlexRow crossAxis="flex-start">
                <FlexColumn width="28px" crossAxis="flex-start">
                    <Icon
                        icon={faClipboardCheck}
                        color={theme.colors.primary}
                        size="M"
                        fixedWidth={true}
                        padding={{ top: 2 }}
                    />
                </FlexColumn>
                <HorizontalDivider />
                <FlexColumn width="100%">
                    <FlexRow>
                        <TextBox
                            text={translation({
                                sv: "Boka direkt – tryggt & enkelt",
                                en: "Book directly – safe & easy",
                            })}
                            userSelect="text"
                            size={"M"}
                            weight={"700"}
                        />
                    </FlexRow>
                    <VerticalDivider XXS />
                    <TextBox
                        text={translation({
                            sv: "Hitta och beställ direkt här. Välj betalmetod som passar dig. Enkelt och säkert.",
                            en: "Find and book directly here. Choose the payment method that suits you. Simple and secure.",
                        })}
                        userSelect="text"
                        size="S"
                        weight="400"
                        color={theme.colors.black.light30}
                        css={{
                            lineHeight: 1.3,
                        }}
                    />
                    <VerticalDivider M />
                </FlexColumn>
            </FlexRow>
            <FlexRow crossAxis="flex-start">
                <FlexColumn width="28px" crossAxis="flex-start">
                    <Icon
                        icon={faUsers}
                        color={theme.colors.primary}
                        size="M"
                        fixedWidth={true}
                        padding={{ top: 2 }}
                    />
                </FlexColumn>
                <HorizontalDivider />
                <FlexColumn width="100%">
                    <FlexRow>
                        <TextBox
                            text={translation({
                                sv: "Dela och upplev tillsammans",
                                en: "Share and enjoy together",
                            })}
                            userSelect="text"
                            size={"M"}
                            weight={"700"}
                        />
                    </FlexRow>
                    <VerticalDivider XXS />
                    <TextBox
                        text={translation({
                            sv: "Dela din bokning eller beställning med vänner eller familj. Tillsammans blir det roligare!",
                            en: "Share your booking or order with friends or family. It’s more fun together!",
                        })}
                        userSelect="text"
                        size="S"
                        weight="400"
                        color={theme.colors.black.light30}
                        css={{
                            lineHeight: 1.3,
                        }}
                    />
                    <VerticalDivider M />
                </FlexColumn>
            </FlexRow>
            <FlexRow crossAxis="flex-start">
                <FlexColumn width="28px" crossAxis="flex-start">
                    <Icon
                        icon={faHeart}
                        color={theme.colors.primary}
                        size="M"
                        fixedWidth={true}
                        padding={{ top: 2 }}
                    />
                </FlexColumn>
                <HorizontalDivider />
                <FlexColumn width="100%">
                    <FlexRow>
                        <TextBox
                            text={translation({
                                sv: "Klart på studs, ser fram emot din vistelse!",
                                en: "Ready in an instant, looking forward to your stay!",
                            })}
                            userSelect="text"
                            size={"M"}
                            weight={"700"}
                        />
                    </FlexRow>
                    <VerticalDivider XXS />
                    <TextBox
                        text={translation({
                            sv: "Du får bekräftelse på momangen, där finns all information du behöver inför besöket.",
                            en: "You will receive confirmation immediately, where you will find all the information you need for your visit.",
                        })}
                        userSelect="text"
                        size="S"
                        weight="400"
                        color={theme.colors.black.light30}
                        css={{
                            lineHeight: 1.3,
                        }}
                    />
                </FlexColumn>
            </FlexRow>
        </FlexColumn>
    );
};

export { AccommodationUspInfoBlock };
